"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrichAISetProductBeingReclassified = exports.enrichAISetPageSize = exports.enrichAISetIsListViewMode = exports.enrichAISetIsAggregatedAttributeViewHidden = exports.enrichAISetProductTreeFilters = exports.enrichAIClearAttributesFilter = exports.enrichAISetAttributesFilter = exports.enrichAISetAttributeCollapseState = exports.enrichAISetAttributesSort = exports.enrichAISetAttributesExcludedItems = exports.enrichAISetSelectedAttributeNode = exports.enrichAISetExpandedNodes = exports.enrichAIRemoveChanges = exports.enrichAIAddChanges = exports.enrichAISetProductTree = exports.enrichAISetSelectedTreeNodePath = exports.enrichAISetProjectTags = exports.enrichAISetSelectedProject = exports.enrichAISetCatalogTags = exports.enrichAISetSelectedCatalog = void 0;
const Actions = __importStar(require("../types/enrich-ai"));
const utils_1 = require("../utils");
const enrichAISetSelectedCatalog = (selectedCatalog) => (0, utils_1.createAction)(Actions.ENRICH_AI_SET_SELECTED_CATALOG, { selectedCatalog });
exports.enrichAISetSelectedCatalog = enrichAISetSelectedCatalog;
const enrichAISetCatalogTags = (id, tags) => (0, utils_1.createAction)(Actions.ENRICH_AI_SET_CATALOG_TAGS, { id, tags });
exports.enrichAISetCatalogTags = enrichAISetCatalogTags;
const enrichAISetSelectedProject = (selectedProject) => (0, utils_1.createAction)(Actions.ENRICH_AI_SET_SELECTED_PROJECT, { selectedProject });
exports.enrichAISetSelectedProject = enrichAISetSelectedProject;
const enrichAISetProjectTags = (id, tags) => (0, utils_1.createAction)(Actions.ENRICH_AI_SET_PROJECT_TAGS, { id, tags });
exports.enrichAISetProjectTags = enrichAISetProjectTags;
const enrichAISetSelectedTreeNodePath = (selectedTreeNodePath) => (0, utils_1.createAction)(Actions.ENRICH_AI_SET_SELECTED_TREE_NODE_PATH, { selectedTreeNodePath });
exports.enrichAISetSelectedTreeNodePath = enrichAISetSelectedTreeNodePath;
const enrichAISetProductTree = (productTree) => (0, utils_1.createAction)(Actions.ENRICH_AI_SET_PRODUCT_TREE, { productTree });
exports.enrichAISetProductTree = enrichAISetProductTree;
const enrichAIAddChanges = (catalogId, changes) => (0, utils_1.createAction)(Actions.ENRICH_AI_ADD_CHANGES, { catalogId, changes });
exports.enrichAIAddChanges = enrichAIAddChanges;
const enrichAIRemoveChanges = (catalogId, strategyNodePath) => (0, utils_1.createAction)(Actions.ENRICH_AI_REMOVE_CHANGES, { catalogId, strategyNodePath });
exports.enrichAIRemoveChanges = enrichAIRemoveChanges;
const enrichAISetExpandedNodes = (expandedNodes) => (0, utils_1.createAction)(Actions.ENRICH_AI_SET_EXPANDED_NODES, { expandedNodes });
exports.enrichAISetExpandedNodes = enrichAISetExpandedNodes;
const enrichAISetSelectedAttributeNode = (selectedAttributeNode) => (0, utils_1.createAction)(Actions.ENRICH_AI_SET_SELECTED_ATTRIBUTE_NODE, { selectedAttributeNode });
exports.enrichAISetSelectedAttributeNode = enrichAISetSelectedAttributeNode;
const enrichAISetAttributesExcludedItems = (excludedItems) => (0, utils_1.createAction)(Actions.ENRICH_AI_SET_ATTRIBUTES_EXCLUDED_ITEMS, { excludedItems });
exports.enrichAISetAttributesExcludedItems = enrichAISetAttributesExcludedItems;
const enrichAISetAttributesSort = (sort) => (0, utils_1.createAction)(Actions.ENRICH_AI_SET_ATTRIBUTES_SORT, { sort });
exports.enrichAISetAttributesSort = enrichAISetAttributesSort;
const enrichAISetAttributeCollapseState = (collapseState) => (0, utils_1.createAction)(Actions.ENRICH_AI_SET_ATTRIBUTES_COLLAPSE_STATE, { collapseState });
exports.enrichAISetAttributeCollapseState = enrichAISetAttributeCollapseState;
const enrichAISetAttributesFilter = (filter) => (0, utils_1.createAction)(Actions.ENRICH_AI_SET_ATTRIBUTES_FILTER, { filter });
exports.enrichAISetAttributesFilter = enrichAISetAttributesFilter;
const enrichAIClearAttributesFilter = () => (0, utils_1.createAction)(Actions.ENRICH_AI_CLEAR_ATTRIBUTES_FILTER, {});
exports.enrichAIClearAttributesFilter = enrichAIClearAttributesFilter;
const enrichAISetProductTreeFilters = (productTreeFilters) => (0, utils_1.createAction)(Actions.ENRICH_AI_SET_PRODUCT_TREE_FILTERS, { productTreeFilters });
exports.enrichAISetProductTreeFilters = enrichAISetProductTreeFilters;
const enrichAISetIsAggregatedAttributeViewHidden = (isAggregatedAttributeViewHidden) => (0, utils_1.createAction)(Actions.ENRICH_AI_SET_IS_AGGREGATED_ATTRIBUTE_VIEW_HIDDEN, { isAggregatedAttributeViewHidden });
exports.enrichAISetIsAggregatedAttributeViewHidden = enrichAISetIsAggregatedAttributeViewHidden;
const enrichAISetIsListViewMode = (isListViewMode) => (0, utils_1.createAction)(Actions.ENRICH_AI_SET_IS_LIST_VIEW_MODE, { isListViewMode });
exports.enrichAISetIsListViewMode = enrichAISetIsListViewMode;
const enrichAISetPageSize = (pageSize) => (0, utils_1.createAction)(Actions.ENRICH_AI_SET_PAGE_SIZE, { pageSize });
exports.enrichAISetPageSize = enrichAISetPageSize;
const EnrichAISetProductBeingReclassified = (productBeingReclassified) => (0, utils_1.createAction)(Actions.ENRICH_AI_SET_PRODUCT_BEING_RECLASSIFIED, { productBeingReclassified });
exports.EnrichAISetProductBeingReclassified = EnrichAISetProductBeingReclassified;
